class PredictSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('.search__input');
    this.predict = this.querySelector('.prompt-background');
    this.debouncedOnChange = debounce((event) => {
      this.predictSearchItem(event);
    }, 300);
    if (this.predict) {
      this.input.addEventListener('input', this.debouncedOnChange);
    }
  }

  predictSearchItem(event) {
    var val = event.target.value;
    this.predict.style.display = "block";
    if(val != "") {
      this.predictSearch(val);
    } else {
      this.predict.style.display = "none";
    }
  }

  predictSearch(val) {
      fetch("/search/suggest.json?q="+val+"&resources[type]=collection,product,page,article&resources[limit]=10&resources[options][unavailable_products]=last")
      .then((response) => response.json())
      .then((response) => {
        // this.show();
        var result = response.resources.results;
        this.renderPage(result, val)
        this.renderProduct(result, val)
        this.renderArticle(result, val)
        this.renderCollection(result, val)
             
        if(result.pages.length == 0 && result.products.length == 0 && result.collections.length == 0 && result.articles.length == 0){
          this.querySelector(".no-result").classList.add("show")
        } else {
          this.querySelector(".no-result").classList.remove("show")

        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  renderCollection(result, val) {
      var collection = this.querySelector(".collection-recommendation");
      var collection_wrapper = this.querySelector("div[data-suggest-type=collection]");
      if(collection) {
        collection.innerHTML = "";
        if(result.collections.length > 0) {
          collection_wrapper.style.display ="block";
          var limit = collection.getAttribute("data-limit");
          var load_more = collection_wrapper.querySelector('.search-collection-load-more');
          if (result.collections.length >= limit) {
            load_more.setAttribute("href", routes.search_url + "?type=collection&q="+val);
            load_more.innerHTML = "<span>"+ theme.strings.view_all+ "</span>";
            load_more.classList.add("show");
          }else {
            load_more.classList.remove("show");
          }

          var c =``;
          result.collections.slice(0, limit).map(function(collection) {
          c += `<div class="collection-recommendation-result">
                <a class="collection-title" href="${collection.url}">${collection.title}</a>
                </div>`;
          })
               
          collection.innerHTML = c
        } else {
          collection_wrapper.style.display ="none";
        }
      }
  }

  renderPage(result,val) {
    var page = this.querySelector(".page-recommendation");
    var page_wrapper = this.querySelector("div[data-suggest-type=page]");
       
    if(page) {
      page.innerHTML = "";
      if(result?.pages.length > 0) {
        page_wrapper.style.display ="block";
        var f = ``;
        var limit = page.getAttribute("data-limit");
        var load_more = page_wrapper.querySelector('.search-page-load-more');
        if (result?.pages.length >= limit) {
          load_more.setAttribute("href", routes.search_url + "?type=page&q="+val);
          load_more.innerHTML = "<span>"+ theme.strings.view_all+ "</span>";
          load_more.classList.add("show");
        } else {
          load_more.classList.remove("show");
        }
        result.pages.slice(0, limit).map(function(page){
          f += `<div class="page-wrapper"><a class="page-title" href="${page.url}">${page.title}</a></div>`;
        })
        page.innerHTML = f;
      } else {
        page_wrapper.style.display ="none";
      }
    }
  }

  renderArticle(result,val) {
    var article = this.querySelector(".article-recommendation");
    var article_wrapper = this.querySelector("div[data-suggest-type=article]");
    if(article) {
      article.innerHTML = "";
      if(result.articles.length > 0) {
        article_wrapper.style.display ="block";
        var a = ``;
        var limit = article.getAttribute("data-limit");
        var load_more = article_wrapper.querySelector('.search-article-load-more');
        if (result.articles.length >= limit) {
          load_more.setAttribute("href", routes.search_url + "?type=article&q="+val);
          load_more.innerHTML = "<span>"+ theme.strings.view_all+ "</span>";
          load_more.classList.add("show");
        } else {
          load_more.classList.remove("show");
        }
        result.articles.slice(0, limit).map(function(article){
        a += `<div class="article-wrapper">`
        if (article.image != null) {
          a +=`<div class="image-wrapper"><a class="media--portrait media" href="${article.url}"><img src="${article.image}" alt="${article.title}"/></a></div>` 
        }
        a += `<a href="${article.url}" class="article-title">${article.title}</a></div>`;
        })
        article.innerHTML = a
      } else {
        article_wrapper.style.display ="none";
      }
    }
  }

  renderProduct(result,val) {
        var product = this.querySelector(".product-recommendation");
        var product_wrapper = this.querySelector("div[data-suggest-type=product]");
        if(product) {
          product.innerHTML = ""
          if(result.products.length > 0) {
            product_wrapper.style.display ="block";
            var limit = product.getAttribute("data-limit");
            var load_more = product_wrapper.querySelector('.search-product-load-more');
            if (result.products.length >= limit) {
              load_more.setAttribute("href", routes.search_url + "?type=product&q="+val);
              load_more.innerHTML = "<span>"+ theme.strings.view_all+ "</span>";
              load_more.classList.add("show");
            }else {
              load_more.classList.remove("show");
            }
            var d =``;
            result.products.slice(0, limit).map(function(product) {
              d += `<div class="product-item">`;
              if (product.image != null) {
                d += `<div class="image-wrapper"><a class="media--portrait media" href="${product.url}"><img alt="${product.title}" src="${product.image}"></a></div>`;
              }
              d += `<div class="product-recommendation-result">
                      <a class="product-title" href="${product.url}">${product.title}</a>
                      <div class="bottom-details">
                        <div class="price">`;
              d += Shopify.formatMoney(product.price);
              d += `</div></div></div></div>`;
            })

            product.innerHTML = d
          } else {
            product_wrapper.style.display ="none";
          } 
        }
  }
}

customElements.define('predict-search', PredictSearch);

